import { useState } from 'react';
import { IonButton, IonSearchbar, IonText } from '@ionic/react';
import { NETWORK_SEARCH_MIN_TERM_LENGTH } from '../../../../appConfig';

interface NetworkSearchBoxProps {
  placeholder: string;
  /** Explanatory line shown under the search box. */
  hint: string;
  loading: boolean;
  /** Called with the term to search, or with '' when the box is emptied. */
  onSearch: (term: string) => void;
}

// Search box of the "Red" tab, shared by the profile and organization searches.
// Emptying it brings back the listing shown before searching.
export const NetworkSearchBox = ({ placeholder, hint, loading, onSearch }: NetworkSearchBoxProps) => {
  const [term, setTerm] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const trimmedTerm = term.trim();
  const canSearch = trimmedTerm.length >= NETWORK_SEARCH_MIN_TERM_LENGTH;

  const handleInput = (value: string) => {
    setTerm(value);
    if (value.trim().length === 0 && hasSearched) {
      setHasSearched(false);
      onSearch('');
    }
  };

  const handleSearch = () => {
    if (!canSearch) return;

    setHasSearched(true);
    onSearch(trimmedTerm);
  };

  return (
    <div className="space-y-2">
      <IonSearchbar
        value={term}
        onIonInput={(event) => handleInput(event.detail.value ?? '')}
        onIonClear={() => handleInput('')}
        onKeyDown={(event) => {
          if (event.key === 'Enter') handleSearch();
        }}
        placeholder={placeholder}
        debounce={0}
      />

      {trimmedTerm.length > 0 && !canSearch && (
        <IonText color="medium">
          <p className="m-0 px-4 text-sm">
            Escribe al menos {NETWORK_SEARCH_MIN_TERM_LENGTH} caracteres para buscar
          </p>
        </IonText>
      )}

      <IonButton expand="block" onClick={handleSearch} disabled={!canSearch || loading}>
        {loading && hasSearched ? 'Buscando...' : 'Buscar'}
      </IonButton>

      <p className="m-0 px-1 text-sm text-slate-500">{hint}</p>
    </div>
  );
};
